<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Réponse de la demande de déverrouillage de dossier</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <p class="text">
                L'utilisateur "{{ data.userName }}" a {{ data.accept === true ? 'accepté' : 'décliné' }} votre demande de déverrouillage du dossier "{{ data.folderName }}"
            </p>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="close()" style="visibility: hidden">Cancel</button>
        <button mat-raised-button class="accent-button" (click)="close()">Fermer</button>
    </mat-card-actions>
</mat-card>
